import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';

import RichEditorContent from 'components/RichEditorContent';

import AbstractCmsElement from './AbstractCmsElementNew';


export default class CmsElementText extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  render() {
    const { textSubstitute } = this.props;
    const { shown } = this.state;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
    const content = this.getParamValue('content') || '';

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={'ms-text relative ' + shownClass + this.getResponsiveClasses() + this.getCssClasses()}
        style={{ ...this.getBackgroundStyle() }}
      >
        {this.getElementStyle()}
        <RichEditorContent
          content={'<div className="text-' + this.getParamValue('mainColor', 'master') + '">' + content + '</div>'}
          textSubstitute={textSubstitute}
        />
        {this.getAppendHtml()}
      </div>
    );

    return (
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>

    );
  }
}
CmsElementText.defaultProps = {
  index: '0',
};
